/* global swal */
import './style.less';

export default function($log, $state, $stateParams, $timeout, Swal, ProfileClass, angularAuth0, store, $http) {
  'ngInject';
  const vm = this;
  vm.$onInit = activate;

  const user_id = store.get('user_id') || undefined;
  const profileUid = $stateParams.id || vm.formData.profile_uid;

  if (user_id === undefined) {
    Swal.alert('Oops', 'Password changes can not be performed at this time.', 'warning');
    $timeout(() => {
      $state.go('login');
    }, 0);
  }

  function password() {
    let encoded = encodeURI(user_id);
    $http({
      method: 'PATCH',
      url: 'https://cpesuite.auth0.com/api/v2/users/' + encoded,
      headers: {
        'Content-Type': 'application/json',
        Authorization:
          'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhdWQiOiJ0d0dxSkxCemFmUEV5VmQ5ZWMwYU5PemlJVE1LVkx3MyIsInNjb3BlcyI6eyJ1c2VycyI6eyJhY3Rpb25zIjpbInVwZGF0ZSJdfX0sImlhdCI6MTQ4MDYyMzY2MywianRpIjoiYjVhZDkxZTczMWM0M2MzZWUwYzY4ZWJhNWZlYjkzMzEifQ._wOVVjHM1USVTMyhUguaWfg3pK7alk4wV17BZgCCS_w'
      },
      data: {
        password: vm.passwordData.newPassword,
        verify_password: false
      }
    }).then(
      function successCallback() {
        vm.passwordUpdate = false;
        delete vm.passwordData.newPassword;
        delete vm.passwordData.verifyPassword;
        Swal.toast('Your password has been updated!').then(() =>
          $state.go('app.users.settings.profile', { id: profileUid })
        );
      },
      function errorCallback() {
        vm.passwordUpdate = false;
        swal('Oops...', 'Something went wrong!', 'error');
        delete vm.passwordData.newPassword;
        delete vm.passwordData.verifyPassword;
      }
    );
  }

  vm.updatePassword = () => {
    if (vm.passwordData.newPassword === vm.passwordData.verifyPassword) {
      vm.passwordUpdate = true;
      return password();
    }
    swal('Oops...', 'Passwords must match!', 'error');
    delete vm.passwordData.newPassword;
    delete vm.passwordData.verifyPassword;
  };

  function activate() {
    $log.debug('User Change Password Activated');
    vm.resultsQueried = false;
    vm.formData = ProfileClass.userProfile;
    vm.passwordData = {};
    vm.passwordUpdate = false;

    $timeout(() => {
      vm.resultsQueried = true;
    }, 0);
  }
}



// WEBPACK FOOTER //
// ./src/app/controllers/users/account/changePassword/index.js